import React, { useEffect, useState } from "react";
import { Archive, ArchiveRestore, UserCheck, Send, X } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export const BulkBar = ({ ids, onClear, onDone }) => {
  const [staff, setStaff] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/users").then((r) => setStaff(r.data.filter((u) => ["admin", "operations", "compliance"].includes(u.role)))).catch(() => {}); }, []);
  const run = async (action, extra = {}) => {
    setBusy(true);
    try {
      const { data } = await api.post("/properties/bulk", { ids, action, ...extra });
      toast.success(`${data.ok.length} propert${data.ok.length === 1 ? "y" : "ies"} updated`);
      data.failed.forEach((f) => toast.error(`${f.title}: ${f.reason}`));
      onDone();
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="bulk-bar" className="sticky top-2 z-20 flex flex-wrap items-center gap-2 bg-[#18181A] text-white rounded-md px-4 py-2.5 shadow-lg">
      <span data-testid="bulk-count" className="text-sm font-medium mr-2">{ids.length} selected</span>
      <Select value="" onValueChange={(v) => run("assign", { manager_id: v === "none" ? null : v })}>
        <SelectTrigger data-testid="bulk-assign" disabled={busy} className="h-8 w-48 bg-white/10 border-white/20 text-white text-xs"><UserCheck className="h-3.5 w-3.5 mr-1" /><SelectValue placeholder="Assign manager…" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Nobody</SelectItem>
          {staff.map((s) => <SelectItem key={s.id} value={s.id} data-testid={`bulk-assign-${s.id}`}>{s.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button size="sm" variant="secondary" className="h-8" data-testid="bulk-send-onboarding" disabled={busy} onClick={() => run("send_onboarding")}><Send className="h-3.5 w-3.5 mr-1" />Resend onboarding</Button>
      <Button size="sm" variant="secondary" className="h-8" data-testid="bulk-archive" disabled={busy} onClick={() => run("archive")}><Archive className="h-3.5 w-3.5 mr-1" />Archive</Button>
      <Button size="sm" variant="secondary" className="h-8" data-testid="bulk-unarchive" disabled={busy} onClick={() => run("unarchive")}><ArchiveRestore className="h-3.5 w-3.5 mr-1" />Restore</Button>
      <button type="button" data-testid="bulk-clear" onClick={onClear} className="ml-auto text-white/70 hover:text-white"><X className="h-4 w-4" /></button>
    </div>
  );
};
